<template>
    <form class="cabinet-settings-brands__tab" @submit.prevent="onSave">
        <div class="cabinet-settings-brands__logo">
            <div
                class="cabinet-settings-brands__logo-img"
                :style="logoBg"
                @click="onAddImage()"
            ></div>
            <input
                ref="brandLogo"
                type="file"
                accept="image/*"
                class="hide"
                @change="onImgInputChange()"
            />
            <button
                type="button"
                class="cabinet-btn--edit-img js-uploaded-img-btn"
                :class="{ hide: !image }"
                @click="onAddImage()"
            ></button>
        </div>

        <div v-if="$v.image.$dirty && $v.image.$invalid" class="error-label">
            Добавьте изображение
        </div>
        <div v-if="errors.updateBrand.image" class="error-label">
            {{ errors.updateBrand.image[0] }}
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="brand_title"
                >Название</label
            >
            <input
                id="brand_title"
                v-model="BrandName"
                type="text"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.BrandName.$dirty && $v.BrandName.$invalid) ||
                        errors.updateBrand.BrandName
                }"
            />
            <div
                v-if="$v.BrandName.$dirty && $v.BrandName.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateBrand.BrandName" class="error-label">
                {{ errors.updateBrand.BrandName[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="brand_email">
                Электронная почта для уведомлений по заказам
            </label>
            <input
                id="brand_email"
                v-model="Email"
                type="text"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.Email.$dirty && $v.Email.$invalid) ||
                        errors.updateBrand.Email
                }"
            />
            <div
                v-if="$v.Email.$dirty && $v.Email.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateBrand.Email" class="error-label">
                {{ errors.updateBrand.Email[0] }}
            </div>
        </div>

        <!-- <div class="cabinet-form-group">
            <label
                class="cabinet-form-group__label"
                for="brand_phone"
                >Телефон</label
            >
            <input
                id="brand_phone"
                type="phone"
                class="cabinet-form-group__input"
                value="+78002340797"
            />
            <button
                type="button"
                class="cabinet-btn cabinet-btn--default cabinet-btn--add cabinet-btn--small mt-10"
            >
                Добавить телефон
            </button>
        </div> -->

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label" for="brand_wa"
                >WhatsApp</label
            >
            <input
                id="brand_wa"
                v-model="Whatsapp"
                type="text"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.Whatsapp.$dirty && $v.Whatsapp.$invalid) ||
                        errors.updateBrand.Whatsapp
                }"
            />
            <div
                v-if="$v.Whatsapp.$dirty && $v.Whatsapp.$invalid"
                class="error-label"
            >
                Введите корректный номер
            </div>
            <div v-if="errors.updateBrand.Whatsapp" class="error-label">
                {{ errors.updateBrand.Whatsapp[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label" for="brand_phone"
                >Телефон</label
            >
            <input
                id="brand_phone"
                v-model="Phones"
                type="tel"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.Phones.$dirty && $v.Phones.$invalid) ||
                        errors.updateBrand.Phones
                }"
            />
            <div
                v-if="$v.Phones.$dirty && $v.Phones.$invalid"
                class="error-label"
            >
                Введите корректный номер
            </div>
            <div v-if="errors.updateBrand.Phone" class="error-label">
                {{ errors.updateBrand.Phones[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="brand_site"
                >Сайт</label
            >
            <input
                id="brand_site"
                v-model="WWW_Site"
                type="text"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.WWW_Site.$dirty && $v.WWW_Site.$invalid) ||
                        errors.updateBrand.WWW_Site
                }"
            />
            <div
                v-if="$v.WWW_Site.$dirty && $v.WWW_Site.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateBrand.WWW_Site" class="error-label">
                {{ errors.updateBrand.WWW_Site[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label" for="brand_vk"
                >Vkontakte</label
            >

            <div class="position-relative">
                <span class="cabinet-form-group__placeholder">vk.com/</span>
                <input
                    id="brand_vk"
                    v-model="WWW_Vkontakte"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            ($v.WWW_Vkontakte.$dirty &&
                                $v.WWW_Vkontakte.$invalid) ||
                            errors.updateBrand.WWW_Vkontakte
                    }"
                    style="padding-left: 62px;"
                />
            </div>

            <div
                v-if="$v.WWW_Vkontakte.$dirty && $v.WWW_Vkontakte.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateBrand.WWW_Vkontakte" class="error-label">
                {{ errors.updateBrand.WWW_Vkontakte[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label" for="brand_fb"
                >Facebook</label
            >

            <div class="position-relative">
                <span class="cabinet-form-group__placeholder"
                    >facebook.com/</span
                >
                <input
                    id="brand_fb"
                    v-model="WWW_Facebook"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            ($v.WWW_Facebook.$dirty &&
                                $v.WWW_Facebook.$invalid) ||
                            errors.updateBrand.WWW_Facebook
                    }"
                    style="padding-left: 107px;"
                />
            </div>

            <div
                v-if="$v.WWW_Facebook.$dirty && $v.WWW_Facebook.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateBrand.WWW_Facebook" class="error-label">
                {{ errors.updateBrand.WWW_Facebook[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label" for="brand_insta"
                >Instagram</label
            >

            <div class="position-relative">
                <span class="cabinet-form-group__placeholder"
                    >instagram.com/</span
                >
                <input
                    id="brand_insta"
                    v-model="WWW_Instagram"
                    type="text"
                    class="cabinet-form-group__input"
                    :class="{
                        error:
                            ($v.WWW_Instagram.$dirty &&
                                $v.WWW_Instagram.$invalid) ||
                            errors.updateBrand.WWW_Instagram
                    }"
                    style="padding-left: 113px;"
                />
            </div>

            <div
                v-if="$v.WWW_Instagram.$dirty && $v.WWW_Instagram.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить
            </div>
            <div v-if="errors.updateBrand.WWW_Instagram" class="error-label">
                {{ errors.updateBrand.WWW_Instagram[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="brand_descr"
                >Описание</label
            >
            <textarea
                id="brand_descr"
                v-model="Description"
                class="cabinet-form-group__textarea cabinet-form-group__textarea--resizable"
                placeholder="Описание"
                :class="{
                    error:
                        ($v.Description.$dirty && $v.Description.$invalid) ||
                        errors.updateBrand.Description
                }"
            ></textarea>
            <div class="cabinet-form-group__textarea-chars js-chars-count">
                <span>{{ Description ? Description.length : 0 }}</span
                >/5000
            </div>

            <div
                v-if="$v.Description.$dirty && $v.Description.$invalid"
                class="error-label"
            >
                Поле необходимо заполнить, максимум 5000 символов
            </div>
            <div v-if="errors.updateBrand.Description" class="error-label">
                {{ errors.updateBrand.Description[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <button
                type="submit"
                class="cabinet-btn"
                :class="{ loading: loading }"
                :disabled="loading"
            >
                {{ getActiveBrand ? 'Сохранить изменения' : 'Добавить' }}
            </button>
        </div>

        <div
            v-if="brands.length && getActiveBrand"
            class="cabinet-form-group d-flex flex-column flex-lg-row align-items-lg-center"
        >
            <button
                type="button"
                class="cabinet-btn cabinet-btn--default align-self-start align-self-lg-center"
                :disabled="brands.length === 1"
                @click="openDeleteBrandModal"
            >
                Удалить бренд
            </button>
            <span
                v-if="brands.length === 1"
                class="pt-3 pt-lg-0 pl-lg-3 cabinet-settings-brands__delete-info text-n700"
            >
                Наличие хотя бы одного бренда является обязательным условием для
                работы на площадке. Невозможно удалить единственный бренд.
            </span>
        </div>

        <delete-brand
            v-if="getActiveBrand"
            :brand-id="getActiveBrand.BrandID"
            :products-count="getActiveBrand.items_count"
            :is-open="isDeleteBrandModalOpen"
            @closeModal="closeDeleteBrandModal"
            @deleteBrandSaved="onDeleteBrandSaved"
        />
    </form>
</template>

<script>
import DeleteBrand from '@/components/Cabinet/Supplier/Settings/DeleteBrand'
import { required, requiredIf, maxLength, url } from 'vuelidate/lib/validators'
import getBgStyles from '@/utils/getBgStyles'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

const validations = {
    BrandName: {
        required,
        maxLength: maxLength(150)
    },
    Email: {
        required,
        maxLength: maxLength(191)
    },
    WWW_Site: {
        required
        // url
    },
    WWW_Vkontakte: {},
    WWW_Facebook: {},
    WWW_Instagram: {},
    Whatsapp: {},
    Phones: {},
    Description: {
        required,
        maxLength: maxLength(5000)
    },
    image: {
        required: requiredIf(function() {
            return !this.getActiveBrand
        })
    }
}

export default {
    name: 'SupplierBrand',
    components: { DeleteBrand },
    data() {
        return {
            loading: false,
            isDeleteBrandModalOpen: false,
            BrandName: '',
            Email: '',
            WWW_Site: '',
            WWW_Vkontakte: '',
            WWW_Facebook: '',
            WWW_Instagram: '',
            Whatsapp: '',
            Phones: '',
            Description: '',
            image: ''
        }
    },
    validations,
    computed: {
        ...mapState('user', ['user']),
        ...mapState('supplierBrand', ['brands', 'errors']),
        ...mapGetters('supplierBrand', ['getActiveBrand']),
        logoBg() {
            if (!this.image) return null
            return getBgStyles(this.image)
        }
    },
    watch: {
        getActiveBrand: {
            handler: function(val) {
                this.$v.$reset()
                this.setFields()
            },
            deep: true
        }
    },
    mounted() {
        this.setFields()
    },
    methods: {
        ...mapMutations('supplierBrand', ['SET_ERRORS', 'SET_ACTIVE_BRAND']),
        ...mapActions('supplierBrand', ['createBrand', 'updateBrand']),
        setFields() {
            this.BrandName = this.getActiveBrand
                ? this.getActiveBrand.BrandName
                : ''
            this.Email = this.getActiveBrand
                ? this.getActiveBrand.Email
                : this.user.email
            this.WWW_Site = this.getActiveBrand
                ? this.getActiveBrand.WWW_Site
                : this.user.website
            this.WWW_Vkontakte =
                this.getActiveBrand && this.getActiveBrand.WWW_Vkontakte
                    ? this.getActiveBrand.WWW_Vkontakte.replace(
                          'https://vk.com/',
                          ''
                      )
                    : ''
            this.WWW_Facebook =
                this.getActiveBrand && this.getActiveBrand.WWW_Facebook
                    ? this.getActiveBrand.WWW_Facebook.replace(
                          'https://facebook.com/',
                          ''
                      )
                    : ''
            this.WWW_Instagram =
                this.getActiveBrand && this.getActiveBrand.WWW_Instagram
                    ? this.getActiveBrand.WWW_Instagram.replace(
                          'https://instagram.com/',
                          ''
                      )
                    : ''
            this.Whatsapp = this.getActiveBrand
                ? this.getActiveBrand.Whatsapp
                : ''
            if (this.getActiveBrand) {
                if (
                    this.getActiveBrand.Phones &&
                    this.getActiveBrand.Phones.length > 0
                ) {
                    this.Phones = this.getActiveBrand.Phones[0]
                } else {
                    this.Phones = this.user.phone
                }
            } else {
                this.Phones = this.user.phone
            }
            this.Description = this.getActiveBrand
                ? this.getActiveBrand.Description
                : ''
            this.image = this.getActiveBrand ? this.getActiveBrand.logo : ''
        },
        onAddImage() {
            this.$refs.brandLogo.click()
        },
        onImgInputChange() {
            const input = event.target
            const size = input.files[0].size / 1024 / 1024
            if (size < 2) {
                const reader = new FileReader()
                reader.onload = () => {
                    const dataURL = reader.result

                    this.image = dataURL
                }
                reader.readAsDataURL(input.files[0])
            } else {
                console.log(
                    input.files[0].name + ' Too long file size ' + size + ' mb'
                )
                this.SET_ERRORS({
                    key: 'updateBrand',
                    val: {
                        image: [
                            ' Too long file size ' + size.toFixed(2) + ' mb'
                        ]
                    }
                })
            }
        },
        async onSave() {
            if (this.loading) return

            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true

                let data = {
                    BrandName: this.BrandName,
                    Email: this.Email,
                    WWW_Site: this.WWW_Site,
                    WWW_Vkontakte: this.WWW_Vkontakte,
                    WWW_Facebook: this.WWW_Facebook,
                    WWW_Instagram: this.WWW_Instagram,
                    Whatsapp: this.Whatsapp,
                    Phones: [this.Phones],
                    Description: this.Description
                }

                if (this.image.startsWith('data:image')) {
                    data = {
                        ...data,
                        image: this.image
                    }
                }

                if (this.getActiveBrand) {
                    await this.updateBrand({
                        ...data,
                        BrandID: this.getActiveBrand.BrandID
                    })

                    if (Object.keys(this.errors.updateBrand).length) {
                        this.$notify({
                            type: 'error',
                            text: this.errors.updateBrand.error
                        })
                    } else {
                        this.$notify({
                            type: 'success',
                            text: 'Выполнено успешно'
                        })
                    }
                } else {
                    await this.createBrand(data)
                }

                this.$v.$reset()
                this.loading = false
            } else {
                console.log('Form not valid')
            }
        },
        openDeleteBrandModal() {
            this.isDeleteBrandModalOpen = true
        },
        closeDeleteBrandModal() {
            this.isDeleteBrandModalOpen = false
        },
        onDeleteBrandSaved() {
            console.log('onDeleteBrandSaved')
        }
    }
}
</script>
